const Paid = () => import("./views/Paid.vue");

export default [
  {
    path: "/payments/paid",
    name: "payments.paid",
    component: Paid,

    meta: {
      roles: ["ROLE_PARENT", "ROLE_INSTITUTION_WORKER"],
    },
  },
];
